export const redirectToICTLoginForgotPassword = () => {
  document.location.href = `${
    process.env.REACT_APP_ICT_LOGIN_URL || 'https://login.interflon.com'
  }/#password-forgotten`;
};
